export const INBOUND_PRODUCT_TRANSITION_PARAM = 'myhivve_transition';
export const INBOUND_PRODUCT_TRANSITION_VALUE = 'product';
export const CLIENT_CONTEXT_LOAD_TIMEOUT_MS = 2_000;
export const PRODUCT_TRANSITION_PAINT_TIMEOUT_MS = 250;

const RELATIVE_URL_BASE = 'https://myhivve.invalid';

export function isInboundProductTransition(url: string): boolean {
  try {
    const parsedUrl = new URL(url, RELATIVE_URL_BASE);
    return (
      parsedUrl.searchParams.get(INBOUND_PRODUCT_TRANSITION_PARAM) ===
      INBOUND_PRODUCT_TRANSITION_VALUE
    );
  } catch {
    return false;
  }
}

export function removeInboundProductTransitionMarker(url: string): string {
  if (!isInboundProductTransition(url)) {
    return url;
  }

  const parsedUrl = new URL(url, RELATIVE_URL_BASE);
  parsedUrl.searchParams.delete(INBOUND_PRODUCT_TRANSITION_PARAM);
  return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
}
